import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BaseDisplayModel } from '@common/models/baseDisplayModel';
import { requiredValidator } from '@common/validators/required-validator';

export class UnconfirmMovesDisplayModel extends BaseDisplayModel {
    manipulation: string;
    containerItemIds: any[];
    serviceRequestId: string;
    containerVisitId: number;
    containerNbr: string;
    remark: string;

    constructor(data = null) {
        super();
        if (data) {
            Object.assign(this, data);
        }
    }

    generateGroup() {
        const form = new UntypedFormGroup({
            containerCount: new UntypedFormControl({ value: null, disabled: true }),
            serviceRequestId: new UntypedFormControl({ value: null, disabled: true }),
            manipulation: new UntypedFormControl({ value: null, disabled: true }),
            remark: new UntypedFormControl({ value: null, disabled: false }, requiredValidator())
        });

        form.patchValue(this);
        return form;
    }
}
